import {
  fetchBizoppDetailBasic,
  fetchBizoppVisitLogs,
  fetchBizoppButton,
  fetchBizopPackList,
  fetchBizoppDetailAllInfo,
  getBusinessInfo,
  setContractSignType,
  fetchBizoppUpdateTags,
  bizoppPickIn,
  getBizoppSwitch,
  getWithdrawReason,
  getWithdrawSign,

} from '@/api'
export default {
  getBizoppSwitchFlag({commit, state}, params) {
    return getBizoppSwitch(params).then(res => {
      if (res && res.data) {
        return res.data.onoff
      }
    })
  },
  async getBizoppDetailBasicById({commit, state}, params) {
    const res = await fetchBizoppDetailBasic(params)
    if (res && res.data) {
      commit('updateBizoppDetailBasicInfo', res.data)
      commit('updateBizoppType', res.data.type)
    }
  },
  getShopVisitLogs({commit, state}, params) { // 店铺详情页拜访记录
    return fetchBizoppVisitLogs(params).then(res => {
      return res.data
    })
  },
  async getBizoppButtonGroup({commit, state}, params) {
    const res = await fetchBizoppButton(params)
    if (res && res.data) {
      commit('updateBizoppButtonGroup', res.data.button)
    }
  },
  async getBizoppSignFailedList({commit, state}, params) {
    const res = await fetchBizopPackList(params)
    return res.data
  },
  async getBizoppDetailAllInfo({commit, state}, params) {
    const res = await fetchBizoppDetailAllInfo(params)
    if (res && res.data) {
      commit('updateBizoppAllInfo', res.data)
    }
  },
  async getBusinessInfoByShopId({commit, state}, params) {
    const res = await getBusinessInfo(params)
    if (res && res.data) {
      commit('updateBusinessInfo', res.data)
    }
  },
  // 选择合同类型
  setContractType({ commit, state }, params) {
    let { shopId, signType } = params
    return setContractSignType({
      shopId,
      signType
    }).then(res => {
      return res.data
    })
  },

  // 标记问题门店
  bizoppUpdateTags({ commit, state }, params) {
    let { shopId, tags } = params
    return fetchBizoppUpdateTags({
      shopId,
      tags
    }).then(res => {
      return res.data
    })
  },
  // 捡入商机
  async pickUpBizopp({ commit, state }, params) {
    let res = ''
    try {
      res = await bizoppPickIn({
        ...params
      })
    } catch (e) {
      console.log(e)
    }
    return res
  },
  // 获取撤销签约申请原因
  getWithdrawReason({ commit, state }, params) {
    return getWithdrawReason(params).then(res => {
      if (res && res.data) {
        return res.data
      }
    })
  },
  // 撤销操作
  getWithdrawSign({ commit, state }, params) {
    return getWithdrawSign(params).then(res => {
      if (res && res.data) {
        return res.data
      }
    })
  }
}
